// @flow
import React from 'react';
import CustomModal from '../../../../../elements/CustomModal/CustomModal';
import {makeStyles, Typography} from '@material-ui/core';
import PropTypes from 'prop-types';
import CustomButtom from '../../../../../elements/CustomButton/CustomButton';
import {colors} from '../../../../../assets/styles/colors';
import {useHistory} from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(3),
    gap: theme.spacing(2),
  },
  title: {
    fontWeight: 600,
    fontSize: '1.375rem',
    TextAlign: 'center',
    width: '70%',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    gap: theme.spacing(2),

    '& button': {
      width: '90%',
    },
  },
  textSpan: {
    fontSize: '1rem',
    textAlign: 'center',
    color: colors.grey700,
  },
}));

type Props = {
  open: boolean,
  handleClose: () => void,
};

export default function ConfigCountryModal(props: Props) {
  const {open, handleClose} = props;
  const classes = useStyles();
  const history = useHistory();

  const handleCloseModal = () => {
    handleClose();
  };

  const redirectToConfigCountry = () => {
    history.push('/configure/logistics/shipping');
    handleCloseModal();
  };

  return (
    <CustomModal open={open} handleCloseModal={handleCloseModal}>
      <div className={classes.root}>
        <Typography align="center" gutterBottom className={classes.title}>
          Configuración de país requerida
        </Typography>

        <div className={classes.container}>
          <Typography className={classes.textSpan}>
            Para editar esta tarifa debes configurar el país en zonas de
            reparto.
          </Typography>
        </div>

        <div className={classes.actions}>
          <CustomButtom
            variant="outlined"
            color="primary"
            onClick={handleClose}
          >
            Cerrar
          </CustomButtom>
          <CustomButtom
            variant="contained"
            color="primary"
            onClick={redirectToConfigCountry}
          >
            Configurar
          </CustomButtom>
        </div>
      </div>
    </CustomModal>
  );
}

ConfigCountryModal.propTypes = {
  open: PropTypes.bool,
  handleOpen: PropTypes.func,
  handleClose: PropTypes.func,
};
